import React, {Component} from "react";
import MessaggiRenderSegnalati from "./MessaggiRenderSegnalati.mjs";
import appLib from "../../../libs/appLib.mjs";
import BLib from "../BLib.mjs";
import Glob from "../../../libs/Glob.mjs";
import TextLabel from "../../../controls/TextLabel.mjs";

const prefix = "AdminSegnalazioni";

const AdminSegnalazioni = class extends Component {
	constructor(props) {
		super(props);
		const u = appLib.currentUser();
		this.state = {
			user: u,
			canAdmin: (u?.admin||u?.moderator),
			axle: 'segnalati',
		};
		this.state.messaggi = BLib.data(this.state.axle);
		if ( ! this.state.messaggi || ! this.state.messaggi.length ) {
			if ( typeof this.props.ifEmpty === 'function' ) this.props.ifEmpty();
		}
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('currentUser', ui => {
			this.setState({user: ui, canAdmin: (ui?.admin||ui?.moderator)}, this.calcClassName);
		}, this.uid);
		Glob.register('DatiBacheca-'+this.state.axle, data => {
			this.setState({messaggi: data }, ()=>{
				if ( ! data || ! data.length ) {
					if ( typeof this.props.ifEmpty === 'function' ) this.props.ifEmpty();
				}
			});
		}, this.uid);
		BLib.startPoll();
	}
	componentWillUnmount() {
		BLib.stopPoll();
		Glob.deregister(this.uid);
	}
	render() {
		if ( ! (this.state.messaggi && this.state.messaggi.length) ) return (
			<h4 className={"mt-3"}>
				<TextLabel value={"No items found"} />
			</h4>
		);
		return (
			<div>
				<MessaggiRenderSegnalati
					user={this.state.user}
					axle={this.state.axle}
					data={this.state.messaggi}
				/>
			</div>
		)
	}
}

export default AdminSegnalazioni;
